import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Avatar, Card, Divider, Popover } from "antd";
import { USABLE_ICONS } from "variables/constants";
import { Trophy } from "lucide-react";
import { getEmployeeAwardList } from "../../../../../redux/employeeaward/employeeAwardState";
import dayjs from "dayjs";

const AwardeeDetails = ({ item }) => {
  const colorClass = item?.award_color_class?.toLowerCase();

  const IconComponent =
    item?.award_icon && USABLE_ICONS[item.award_icon]
      ? USABLE_ICONS[item.award_icon]
      : null;
  const name = item?.employee_name || "-";
  const role = item?.employee_position || "-";
  const category = item?.award_title || "-";
  const achievement = item?.ema_feedback || "-";

  const initials =
    item?.employee_name
       ?.split(" ")
      .map((n) => n[0])
      .join("") || "-";

  return (
    <Card className={`rounded-xl card-theme ${colorClass} w-full`}>
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-4 flex-1">
          <div className="relative inline-block">
            <Avatar
              size={64}
              style={{
                background: "linear-gradient(to bottom right, #10b981, #8b5cf6)",
                border: "4px solid white",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
              }}
            >
              {initials}
            </Avatar>

            <Popover
              content={category}
              trigger="hover"
              placement="top"
              overlayClassName="reward-popover"
            >
              <div
                className={`absolute -right-1 -bottom-1 w-8 h-8 !rounded-full icon-style ${colorClass} shadow-lg border-2 border-white flex items-center justify-center cursor-pointer hover:scale-110 transition-transform`}
              >
                {IconComponent &&
                  React.createElement(IconComponent, {
                    className: "w-4 h-4 text-white"
                  })}
              </div>
            </Popover>
          </div>

          <div className="flex flex-col gap-1">
            <h4 className="flex gap-2 font-semibold text-base title-text">
              {name}
              <Trophy className="w-5 h-5 fill-yellow-500 text-yellow-500" />
            </h4>

            <p className="text-xs mb-2 muted-text">{role}</p>

            <span className={`status-indicator ${colorClass} text-xs`}>
              {category}
            </span>
          </div>
        </div>

        <div
          className={`w-16 h-16 icon-style ${colorClass} shadow-lg flex items-center justify-center`}
        >
          {IconComponent &&
            React.createElement(IconComponent, {
              className: "w-8 h-8 text-white"
            })}
        </div>
      </div>

      <Divider style={{ margin: "1rem 0", borderColor: "#e5e7eb" }} />

      <div className="space-y-2">
        <div className="flex items-center justify-between text-[13px]">
          <span className="muted-text">Award Month:</span>
          <span className="font-medium title-text">
            {item?.ema_issued_at
              ? dayjs(item.ema_issued_at).format("MMMM YYYY")
              : "-"}
          </span>
        </div>

        <div>
          <p className="mb-2 muted-text">Achievement:</p>
          <p className="text-[13px] title-text">{achievement}</p>
        </div>
        <div className="bg-gradient-to-r from-emerald-50 to-purple-50 rounded-xl p-4 border border-emerald-200 dark:from-emerald-900 dark:to-purple-900 dark:border-emerald-700">
          <p className="text-[13px] text-center font-medium text-emerald-700 dark:text-emerald-200">
            🎉 Congratulations on your outstanding achievement! 🎉
          </p>
        </div>
      </div>
    </Card>
  );
};

const AvatarGrid = ({ recordList, pagination, doSearch }) => {
  useEffect(() => {
    doSearch({paginate: pagination.per_page});
  }, [doSearch, pagination.per_page]);

  const filteredList = recordList?.filter(
    (item) => item?.ema_status_id === 1
  );

  return (
    <div className="flex gap-4 flex-wrap">
      {filteredList?.map((item) => (
        <AwardeeDetails key={item?.ema_id} item={item} />
      ))}
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.employeeAward.employeeAwardList?.items,
  pagination: state.employeeAward.employeeAwardList?.pagination,
  requesting: state.employeeAward.employeeAwardList?.requesting
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getEmployeeAwardList(filters))
});

export default connect(mapStateToProps, mapDispatchToProps)(AvatarGrid);